import {Component} from "@angular/core";
import {DICTIONARY} from "../../../dictionary";
import {RouteService} from "../../../services/routeService";


@Component({
	selector: 'threat-simulation-not-supported',
	templateUrl: './not-supported.component.html',
	styleUrls: ['./not-supported.component.scss']
})
export class ThreatSimulationNotSupportedComponent {

	dic = DICTIONARY;
	startingTrial = false;

	constructor(private rs: RouteService) {
	}

	startFreeTrial() {
		if (this.startingTrial) {
			return;
		}

		this.startingTrial = true;
		this.rs.enableThreatSimulationFreeTrial().then(() => {
			window.location.reload();
		}).catch(() => {
			this.startingTrial = false;
		});
	}
}
